import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames/bind";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Navigation } from "swiper";

// component
import EventItem from "../EventItem";

// network
import { fetchNearByEvents } from "src/content/MapContent/utils/network";

// context
import UserContext from "src/context/User";

import styles from "./Slider.module.scss";
const cx = classNames.bind(styles);
SwiperCore.use([Navigation]);

const Slider = () => {
  // context
  const { user, userLocation } = useContext(UserContext);

  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (user || userLocation) {
      let coords = {};

      if (user) {
        coords.lat = user.location.lat;
        coords.lng = user.location.lng;
      } else {
        coords.lat = userLocation.lat;
        coords.lng = userLocation.lng;
      }

      fetchEvents(coords, 50);
    }
  }, [user, userLocation]);

  const fetchEvents = (_coords, _raduis) => {
    let data = {
      lat: _coords.lat,
      lng: _coords.lng,
      radius: _raduis,
    };

    fetchNearByEvents(data)
      .then((res) => {
        if (res.data.Status) {
          setEvents(res.data.Results.Events);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (events.length === 0) {
    return null;
  }

  console.log(events);

  return (
    <div className={`interesting-events ${cx("slider-root")}`}>
      <Swiper
        spaceBetween={12}
        slidesPerView="auto"
        slidesPerGroup={1}
        loop={true}
        navigation={true}
        centeredSlides={true}
        cssMode
        freeMode={{
          enabled: true,
          sticky: true,
        }}
        breakpoints={{
          640: {
            centeredSlides: false,
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          768: {
            centeredSlides: false,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          900: {
            centeredSlides: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1280: {
            centeredSlides: false,
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
        }}
      >
        {events.map((item, index) => (
          <SwiperSlide key={index}>
            <EventItem data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
